import React from 'react';
import styled from 'styled-components';
import Text from '../../ui/Text';
import ArrowWhite from '../../features/SpilID/assets/arrowWhite.svg';
import { connect } from 'react-redux';
import { browserHistoryGoBack } from '../../utils/UiHelper';

const BackButtonWrapper = styled.button`
    height: auto;
    width: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 9px 15px;
    background: #455a75 0 0 no-repeat padding-box;
    border-radius: 5px;
    border: none;
    outline: none;
    position: fixed;
    top: 75px;
    left: 90px;
    z-index: 5;
    transition: all 0.1s ease-in-out;
    &.open {
        left: 280px;
    }
    &:hover {
        cursor: pointer;
    }
    img {
        display: inline-block;
        box-sizing: border-box;
        transform: rotate(180deg);
    }
    p {
        width: auto;
    }
`;

const BackButton = ({ isLeftSideBarOpen, eventTitle }) => {
    return (
        <BackButtonWrapper
            onClick={browserHistoryGoBack}
            className={`${isLeftSideBarOpen ? 'open' : ''} `}
        >
            <img src={ArrowWhite} alt="" />
            <Text color={'#fff'} center size="12" bold padding="0" margin={'0'}>
                {eventTitle}
            </Text>
        </BackButtonWrapper>
    );
};

function mapStateToProps(state) {
    return {
        isLeftSideBarOpen: state.ui.leftSidebarOpen,
    };
}

export default connect(
    mapStateToProps,
    null
)(BackButton);
